import { connect } from 'react-redux';
import moment from 'moment';

import { FIELD_ACTION_MAP } from 'actions/bind';

// reducer selector ex. ['auth', 'signupForm', 'email']
const selector = (state, [key, ...other]) => {
	if (state[key]) {
		if (other.length > 0) {
			return selector(state[key], other);
		}
		return state[key];
	}
	return '';
};

// bind reducer HOC ex. ('auth', 'signupForm', 'email') => (Field) => Component
export const bindField = (key, ...other) => Component => {
	const mapStateToProps = state => ({
		value: selector(state, [key, ...other]).value,
	});

	const action = FIELD_ACTION_MAP[key];
	const mapDispatchToProps = dispatch => ({
		onChange: (e, c = null) => {
			if (c !== null) {
				dispatch(action(...other, { value: c }));
			} else {
				dispatch(action(...other, { value: e.target.value }));
			}
		},
	});

	return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export const bindSelector = (key, ...other) => Component => {
	const mapStateToProps = state => ({
		value: selector(state, [key, ...other]).value,
	});

	const action = FIELD_ACTION_MAP[key];

	const mapDispatchToProps = dispatch => ({
		onChange: select => dispatch(action(...other, { value: select })),
	});

	return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export const bindDropdown = (key, ...other) => Component => {
	const mapStateToProps = state => ({
		value: selector(state, [key, ...other]).value,
	});

	const action = FIELD_ACTION_MAP[key];

	const mapDispatchToProps = dispatch => ({
		onChange: value => dispatch(action(...other, { value })),
	});

	return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export const bindSearchTag = (key, ...other) => Component => {
	const mapStateToProps = state => ({
		value: selector(state, [key, ...other]).value,
	});

	const action = FIELD_ACTION_MAP[key];

	const mapDispatchToProps = dispatch => ({
		onChange: value => dispatch(action(...other, { value })),
		onChangeInputValue: value => dispatch(action(...other, { inputValue: value })),
	});

	return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export const bindFieldTel = (key, ...other) => Component => {
	const mapStateToProps = state => ({
		value: selector(state, [key, ...other]).value,
		country: selector(state, [key, ...other]).country,
		defaultCountry: selector(state, [key, ...other]).country.iso2,
		status: selector(state, [key, ...other]).status,
	});

	const action = FIELD_ACTION_MAP[key];

	const mapDispatchToProps = dispatch => ({
		onPhoneNumberChange: (validate, phone, country) => {
			dispatch(action(...other, { value: phone, country, validate }));
		},
		onSelectFlag: (_, country) => {
			dispatch(action(...other, { value: '', country, validate: false }));
		},
	});

	return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export const bindDatePicker = (key, ...other) => Component => {
	const mapStateToProps = state => {
		const date = selector(state, [key, ...other]).value;

		return {
			date: date === '' ? null : moment(date, 'X'),
		};
	};

	const action = FIELD_ACTION_MAP[key];

	const mapDispatchToProps = dispatch => ({
		onDateChange: selectedDate => dispatch(action(...other, { value: selectedDate.format('X') })),
	});

	return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export const bindDropdownBirthday = (key, ...other) => Component => {
	const mapStateToProps = state => {
		const { i18n: { lan } } = state;
		const date = selector(state, [key, ...other]).value;

		return {
			value:
				date === '' ? '' : moment(date, 'X').format(lan === 'en' ? 'MMM/DD/YYYY' : 'YYYY/MM/DD'),
			date: date === '' ? null : moment(date, 'X'),
		};
	};

	const action = FIELD_ACTION_MAP[key];

	const mapDispatchToProps = dispatch => ({
		onDateChange: selectedDate => dispatch(action(...other, { value: selectedDate.format('X') })),
	});

	return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export const bindDropdownMonthRange = (key, ...other) => Component => {
	const mapStateToProps = state => selector(state, [key, ...other]).value;

	const action = FIELD_ACTION_MAP[key];

	const mapDispatchToProps = dispatch => ({
		onChange: value => dispatch(action(...other, { value })),
	});

	return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export const bindToggleButton = (key, ...other) => Component => {
	const mapStateToProps = state => ({
		checked: selector(state, [key, ...other]).value,
	});

	const action = FIELD_ACTION_MAP[key];

	const mapDispatchToProps = dispatch => ({
		onChange: e => dispatch(action(...other, { value: e.target.checked })),
	});

	return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export const bindCheckbox = (key, ...other) => Component => {
	const mapStateToProps = state => ({
		checked: selector(state, [key, ...other]).value,
	});

	const action = FIELD_ACTION_MAP[key];

	const mapDispatchToProps = dispatch => ({
		onChange: (_, checked) => dispatch(action(...other, { value: checked })),
	});

	return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export const bindCertificate = (key, ...other) => Component => {
	const mapStateToProps = state => ({
		type: selector(state, [key, ...other]).type,
		value: selector(state, [key, ...other]).value,
	});

	const action = FIELD_ACTION_MAP[key];

	const mapDispatchToProps = dispatch => ({
		onTypeChange: value => {
			dispatch(action(...other, { type: value }));
		},
		onValueChange: e => {
			dispatch(action(...other, { value: e.target.value }));
		},
	});

	return connect(mapStateToProps, mapDispatchToProps)(Component);
};



// WEBPACK FOOTER //
// ./src/util/bind.js